<template>
<div v-if="record" class="mdl-grid">
  <h3 class="mdl-cell mdl-cell--12-col">
    <i v-if="record.changed" class="material-icons">edit</i> {{ record.product.name }} <br>
    <span class="subheader">
      <template v-if="record.product.variety">{{ record.product.variety }},</template>
        {{ record.product.origin }},
        {{ record.product.unit }}
    </span>
  </h3>
  
  <div class="mdl-cell mdl-cell--6-col mdl-cell--6-col-tablet">
    <h4>Ceny do publikacji</h4>
    <div v-for="(price, index) in record.draftPrices">
      <currency-input v-model="price.price" @input.native="priceChanged" class="bigger-font"></currency-input>
      <button @click="removeDraftPrice(record, index)" class="mdl-button mdl-js-button mdl-button--fab mdl-button--mini-fab">
        <i class="material-icons">delete</i>
      </button>
    </div>
    <button @click="addDraftPrice(record)" class="mdl-button mdl-js-button mdl-button--fab mdl-button--mini-fab mdl-button--colored">
      <i class="material-icons">add</i>
    </button>
  </div>
  
  <div class="mdl-cell mdl-cell--6-col mdl-cell--6-col-tablet">
    <h4 style="color: gray">Ceny z poprzedniego notowania</h4>
    <div v-for="price in record.previousPrices">
      {{ price.price|currency }}
    </div>
    <br>
    <button
      class="mdl-button mdl-js-button mdl-button--raised mdl-js-ripple-effect"
      @click.prevent="usePreviousPrices"
    >
        Użyj cen z poprzedniego notowania
    </button>
  </div>
  
  <div class="mdl-cell mdl-cell--6-col mdl-cell--6-col-tablet">
    <h4 style="color: gray">Ceny opublikowane</h4>
    <div v-for="price in record.publicPrices">
      {{ price.price|currency }}
    </div>
  </div>
</div>
<my-spinner v-else></my-spinner>
</template>
<script>
import MySpinner from './MySpinner.vue'
import CurrencyInput from './CurrencyInput.vue'
import * as m from './../mutation-types'

export default {
  props: {
    slug: {type: String, required: true},
    id: { type: [Number, String], required: true }
  },
  components: {
    MySpinner,
    CurrencyInput
  },
  computed: {
    record () {
      return this.$store.getters.getRecordBy(this.slug, this.id)
    }
  },
  methods: {
    addDraftPrice (record) {
      this.$store.commit(m.ADD_DRAFT_PRICE, record)
      this.$store.commit(m.RECORD_CHANGED, this.record)
    },
    removeDraftPrice (record, index) {
      this.$store.commit(m.REMOVE_DRAFT_PRICE, {record, index})
      this.$store.commit(m.RECORD_CHANGED, this.record)
    },
    priceChanged () {
      this.$store.commit(m.RECORD_CHANGED, this.record)
    },
    usePreviousPrices () {
      this.$store.commit(m.SET_PREVIOUS_PRICES, {record: this.record, previousPrices: [...this.record.previousPrices]})
    }
  }
}
</script>
<style>
.subheader {
  color: gray;
  font-size: 18px;
}
</style>



// WEBPACK FOOTER //
// RecordEdit.vue?870d9b12